import DownloadCVListings from "../FindWork/SearchDownloadCV/CVFilterListings/DownloadCVListings";

export default function DashboardDownloads() {

  return (
    <div className="downloads">
      <div className="download-first">
        <div>
          <h2 className="font-42">Downloads</h2>
          <h6>Re-download CV’s</h6>
        </div>
      </div>
      <div className="col-md-12 filter-right">
        <DownloadCVListings />
      </div>

    </div>
  );
}
